export { default as OfferSelected } from './offer-selected';
